import d from "../../node_modules/.pnpm/zustand@4.1.1_react@17.0.2/node_modules/zustand/esm/shallow.js";export default d;